import { Routes } from '@angular/router';
import { AppMenuComponent } from '../menus/app-menu/app-menu.component';
import { EventMenuComponent } from '../menus/event-menu/event-menu.component';
import { CanActivateViaAuthGuard } from '../shared/guards/can-activate-via-auth-guard';
import { DashboardRedirectGuard } from '../shared/guards/dashboard-redirect-guard';
import { FinalPaymentAuthorizedGuard } from '../shared/guards/final-payment-authorized.guard';
import { OverviewRedirectGuard } from '../shared/guards/overview-redirect-guard';
import { PermissionGuard } from '../shared/guards/permission-guard';
import { AddEventComponent } from './add-event/add-event.component';
import { AttachmentResolver } from './attachment/attachment.resolver';
import { DashboardComponent } from './dashboard/dashboard-page/dashboard.component';
import { EventListComponent } from './event-list/event-list.component';
import { EventMatchComponent } from './event-match/event-match.component';
import { EventComponent } from './event/event.component';
import { EventResolver } from './event/event.resolver';
import { MatchingPropertyCandidateComponent } from './matching-property/matching-property-candicate/matching-property-candidate.component';
import { MatchingPropertyComponent } from './matching-property/matching-property.component';
import { OverviewPageComponent } from './overview/overview-page/overview-page.component';
import { OverviewResolver } from './overview/overview.resolver';
import { TransactionResolver } from './overview/transaction.resolver';
import { AdjustmentTypeCreditResolver } from './payment/adjustment-type-credit.resolver';
import { AdjustmentTypeDebitResolver } from './payment/adjustment-type-debit.resolver';
import { AdjustmentResolver } from './payment/adjustment.resolver';
import { CommissionComponent } from './payment/commission/commission.component';
import { FinalPaymentStatusResolver } from './payment/final-payment-status.resolver';
import { LatestPaymentResolver } from './payment/latest-payment.resolver';
import { PaymentsResolver } from './payment/payments.resolver';
import { LatestPrepaymentResolver } from './payment/prepayment.resolver';
import { CanDeactiveReservationDetailTable } from './reservations/reservation-detail-table/reservation-detail-can-deactive';
import { ReservationDetailResolver } from './reservations/reservation-detail.resolver';
import { ReservationPageComponent } from './reservations/reservation-page/reservation-page.component';
import { ReservationCompareResolver } from './reservations/reservation.compare.resolver';
import { ReservationResolver } from './reservations/reservation.resolver';
import { TransientReservationComponent } from './reservations/transient-reservation/transient-reservation.component';
import { RsvpCompareResolver } from './rsvp/rsvp-compare.resolver';
import { RsvpDetailResolver } from './rsvp/rsvp-detail.resolver';
import { RsvpComponent } from './rsvp/rsvp-page/rsvp-page.component';
import { RsvpResolver } from './rsvp/rsvp.resolver';
import { ChainResolver } from './service/chainbrand/chain.resolver';
import { CountryResolver } from './service/common-data/country.resolver';
import { CurrencyResolver } from './service/common-data/currency.resolver';
import { EventsResolver } from './service/events.resolver';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [ DashboardRedirectGuard, CanActivateViaAuthGuard ],
    children: [
      {
        path: '',
        outlet: 'navigation',
        component: AppMenuComponent
      },
      {
        path: '',
        component: DashboardComponent
      }
    ]
  },
  {
    path: 'events',
    canActivate: [ CanActivateViaAuthGuard ],
    children: [
      {
        path: '',
        outlet: 'navigation',
        component: AppMenuComponent
      },
      {
        path: '',
        component: EventListComponent,
        resolve: {
          eventsData: EventsResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: { view: 'default' }
      },
      {
        path: 'financial',
        component: EventListComponent,
        resolve: {
          eventsData: EventsResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: { view: 'financial' }
      },
      {
        path: 'add',
        component: AddEventComponent,
        canActivate: [ PermissionGuard ],
        data: { allowedPermissions: [ 'addevent' ] },
        resolve: {
          countriesData: CountryResolver,
          currenciesData: CurrencyResolver,
          chainsData: ChainResolver
        }
      },
      {
        path: 'matching/property',
        component: MatchingPropertyComponent,
        canActivate: [ PermissionGuard ],
        data: { allowedPermissions: [ 'viewInternalReview' ] },
        resolve: {
        }
      },
      {
        path: 'matching/property/candidates',
        component: MatchingPropertyCandidateComponent,
        canActivate: [ PermissionGuard ],
        data: { allowedPermissions: [ 'viewInternalReview' ] },
        resolve: {
        }
      },
      {
        path: 'event-match',
        component: EventMatchComponent,
        /* resolve: {
          eventsData: EventsResolver
        }, */
        /* runGuardsAndResolvers: 'paramsOrQueryParamsChange', */
        /* data: { view: 'financial' } */
      }
    ]
  },
  {
    path: 'event/:id',
    canActivate: [ CanActivateViaAuthGuard ],
    resolve: {
      eventsData: EventResolver,
      countriesData: CountryResolver,
      currenciesData: CurrencyResolver,
      latestPaymentData: LatestPaymentResolver,
      finalPaymentStatusData: FinalPaymentStatusResolver
    },
    children: [
      {
        path: '',
        outlet: 'navigation',
        component: AppMenuComponent,
        children: [
          {
            path: '',
            component: EventMenuComponent,
            outlet: 'event'
          }
        ]
      },
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full'
      },
      {
        path: 'overview',
        component: OverviewPageComponent,
        canActivate: [ OverviewRedirectGuard ],
        resolve: {
          overviewData: OverviewResolver,
          transactions: TransactionResolver,
          reservationData: ReservationResolver,
          rsvpData: RsvpResolver
        }
      },
      {
        path: 'summary',
        component: EventComponent,
        resolve: {
          attachmentData: AttachmentResolver,
          paymentsData: PaymentsResolver
        }
      },
      {
        path: 'summary/edit',
        component: EventComponent,
        resolve: {
          attachmentData: AttachmentResolver,
          reservationData: ReservationResolver,
          rsvpData: RsvpResolver,
          paymentsData: PaymentsResolver,
          latestPrepaymentData: LatestPrepaymentResolver,
          chainsData: ChainResolver
        },
        canActivate: [ PermissionGuard, FinalPaymentAuthorizedGuard ],
        data: { allowedPermissions: [ 'editevent' ] }
      },
      {
        path: 'commission',
        component: CommissionComponent,
        resolve: {
          reservationData: ReservationResolver,
          rsvpData: RsvpResolver,
          adjustmentData: AdjustmentResolver,
          paymentsData: PaymentsResolver,
          latestPrepaymentData: LatestPrepaymentResolver,
          adjustmentTypeCreditData: AdjustmentTypeCreditResolver,
          adjustmentTypeDebitData: AdjustmentTypeDebitResolver
        }
      },
      {
        path: 'rsvp',
        component: RsvpComponent,
        resolve: {
          rsvpData: RsvpCompareResolver
        }
      },
      {
        path: 'rsvp/detail',
        component: RsvpComponent,
        resolve: {
          rsvpDetail: RsvpDetailResolver
        },
        canDeactivate: [CanDeactiveReservationDetailTable]
      },
      {
        path: 'reservations',
        component: ReservationPageComponent,
        resolve: {
          reservations: ReservationCompareResolver,
          reservationData: ReservationResolver
        }
      },
      {
        path: 'reservations/detail',
        component: ReservationPageComponent,
        resolve: {
          reservationsDetail: ReservationDetailResolver
        },
        canDeactivate: [CanDeactiveReservationDetailTable]
      },
      {
        path: 'transient-reservations',
        component: TransientReservationComponent,
        canActivate: [ PermissionGuard ],
        data: { allowedPermissions: [ 'linkreservation' ] }
      }
    ]
  }
];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/event.routes.ts